module.exports = __webpack_public_path__ + "img/noData.df70d331.png";